var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags"},_vm._l((_vm.tags),function(tag,idx){return _c('QueryTag',{key:idx,attrs:{"tagName":tag,"size":"small","type":"info"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }